import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightLong } from '@fortawesome/free-solid-svg-icons';

interface MeasuresTableProps {
  onClose: () => void;
  validMeasures: {
    breath?: Array<{
      age: string;
      breaths: string | number;
      heartbit: string | number;
    }>;
    bloodPressure?: Array<{
      age: string;
      bloodPressure: string | number;
    }>;
  };
}

const MeasuresTable: React.FC<MeasuresTableProps> = ({ onClose, validMeasures }) => {
  return (
    <div className="container content-tables">     
      <table className="table table-striped" style={{ marginTop: 60 }}>
        <thead>
          <tr>
            <th scope="col">גיל</th>
            <th scope="col">מס' נשימות</th>
            <th scope="col">דופק</th>
          </tr>
        </thead>
        <tbody>
          {validMeasures.breath?.map((line, index) => (
            <tr key={`breath-${index}`}>
              <th scope="row">{line.age}</th>
              <td>{line.breaths}</td>
              <td>{line.heartbit}</td>
            </tr>
          ))}
        </tbody>
      </table>
      
      <table className="table table-striped">
        <thead>
          <tr>
            <th scope="col">גיל</th>
            <th scope="col">
              לחץ דם<br />(סיסטולי מינימלי)
            </th>
          </tr>
        </thead>
        <tbody>
          {validMeasures.bloodPressure?.map((line, index) => (
            <tr key={`bp-${index}`}>
              <th scope="row">{line.age}</th>
              <td>{line.bloodPressure}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MeasuresTable;